<template>
    <v-layout row wrap style="height:100%">
           <v-flex class="xs12 md6 offset-md-3">
               <div class="flex pa-2  white elevatin-2 xs12">
                <div class="vertical-spacing"></div>
                 <div class="text-center">
                   <img src="../assets/logo.png" width="300px" />
                    <h2 class=" green--text text--darken-4">CHANGE PASSWORD</h2>
                 </div>
                   <v-container>
                <v-row dense >
                  <v-col  cols="12" md="12">
                    <v-text-field color="green" single-line outlined v-model="currentPassword" type="password" class="mt-2 " label="Current Password" clearable  > 
                  </v-text-field>
                 </v-col>
                  <v-col  cols="12" md="12">
                    <v-text-field color="green" single-line outlined v-model="newPassword" type="password" class="mt-2" label="New Password" clearable > 
                  </v-text-field>
                 </v-col>
                 <v-col  cols="12" md="12">
                    <v-text-field color="green"  single-line outlined v-model="confirmPassword" type="password" class="mt-2" label="Confirm Password" clearable > 
                    </v-text-field>
                 </v-col>
                <v-col cols="12" md="12" align="center">
                 <v-btn xs12 @click="changePassword" rounded large class="green white--text  mt-10 ">Change Password</v-btn>   
                </v-col>
                </v-row>
              </v-container>
               </div>
           </v-flex>
       </v-layout>
  </template>
  
  <script>
  import Axios from 'axios'
  import { BASE_URL } from '../config'
  import { mapGetters } from 'vuex'
  export default {
      data(){
           return{
               currentPassword:"",
               newPassword:"",
               confirmPassword:"",
                            
           }
       },
       methods : {
        async changePassword(){
          if(this.currentPassword != '' && this.confirmPassword != '' && this.newPassword != '' ){

            let payload = {
                            email:this.CHANGEPASSWORD,
                            password: this.currentPassword,
                            newPassword:this.newPassword
            }
                if(this.newPassword == this.confirmPassword){
                    let url =  "http://localhost:5000/api/v1/auth/admin-district/change-password"
                    let {data} = await Axios.post(url,payload)
                                  .then((response) => {
                                    if(response.success = true){
                                      this.$toasted.success(response.data.msg)
                                      this.$router.push('/') 
                                    }
                                    else{
                                      this.$toasted.error(response.data.msg)
                                      
                                    }
                                  })
                      
                }
                 else{
                  this.$toasted.error('Password doesnot match')
                 }         
                
          }
          else{
            this.$toasted.error('Please fill all columns')
          }
            
                }
           
       },
       computed:{
        ...mapGetters(['CHANGEPASSWORD'])
       }
  }
  </script>
  
 